/* M2L Digital Studios - scroll & hover motion (GSAP) */
(function(){
  if (typeof gsap === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);
  gsap.registerEase("m2lSoft", "cubic-bezier(0.25,0.46,0.45,0.94)");
  gsap.registerEase("m2lPremium", "cubic-bezier(0.23,1,0.32,1)");

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initPageLoad(){
    var tl = gsap.timeline({ defaults: { ease: "m2lPremium" } });
    tl.from(".m2l-header", { y: -24, opacity: 0, duration: .7 })
      .from(".m2l-hero-copy h1", { y: 36, opacity: 0, duration: .9 }, "-=0.35")
      .from(".m2l-hero-copy .hero-sub", { y: 24, opacity: 0, duration: .7 }, "-=0.55")
      .from(".m2l-hero-actions .btn", { y: 18, opacity: 0, duration: .6, stagger: .1 }, "-=0.4")
      .from(".m2l-scroll-cue", { opacity: 0, duration: .6 }, "-=0.2")
      .from(".m2l-hero-visual", { opacity: 0, scale: .92, duration: 1.1 }, "-=0.8");
  }

  function initScrollReveals(){
    gsap.utils.toArray("[data-reveal]").forEach(function(el){
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: "top 84%" },
        y: 44,
        opacity: 0,
        duration: .85,
        ease: "m2lSoft"
      });
    });

    gsap.utils.toArray("[data-reveal-group]").forEach(function(group){
      var items = group.querySelectorAll("[data-reveal-item]");
      if (!items.length) return;
      gsap.from(items, {
        scrollTrigger: { trigger: group, start: "top 80%" },
        y: 40,
        opacity: 0,
        duration: .7,
        stagger: .12,
        ease: "m2lSoft"
      });
    });

    // Single-image entrance (e.g. the About page founder photo): hidden until
    // its own section is meaningfully in view, then fades up with a scale-in -
    // same premium treatment as the hero visual (.92 scale, m2lPremium ease),
    // plus a rise. Text siblings are untouched, so copy stays static/visible.
    gsap.utils.toArray("[data-reveal-photo]").forEach(function(el){
      el.style.willChange = "transform, opacity";
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: "top 78%" },
        y: 56,
        scale: .93,
        opacity: 0,
        duration: 1.1,
        ease: "m2lPremium",
        onComplete: function(){ el.style.willChange = "auto"; }
      });
    });
  }

  function initHover(){
    document.querySelectorAll(".offer-card, .portfolio-card").forEach(function(card){
      card.addEventListener("mouseenter", function(){
        gsap.to(card, { y: -6, duration: .32, ease: "power2.out" });
      });
      card.addEventListener("mouseleave", function(){
        gsap.to(card, { y: 0, duration: .4, ease: "power2.inOut" });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function(){
    document.body.classList.remove("no-js");
    if (prefersReduced){
      gsap.set("[data-reveal], [data-reveal-item], [data-reveal-photo]", { clearProps: "all" });
      return;
    }
    initPageLoad();
    initScrollReveals();
    initHover();
  });

  window.addEventListener("load", function(){
    ScrollTrigger.refresh();
  });
})();
